import { env } from "@/env";

// export const getAccessToken = (): null | string => {
//   return getUserData()?.access_token || null;
// };

export class HttpError extends Error {
  errorType: string;
  message: string;
  status: number;
  data?: Record<string, unknown>;

  constructor(status: number, message: string, errorType: string, data?: Record<string, unknown>) {
    super(message);
    this.name = "HttpError";
    this.status = status;
    this.errorType = errorType;
    this.message = message;
    this.data = data;

    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

async function throwErrorIfResponseNotOk(response: Response) {
  if (!response.ok) {
    try {
      const error = await response.json();
      const message = error.detail?.message || response.statusText;
      const errorType = error.detail?.status || response.statusText;
      const data = error.detail?.data as Record<string, unknown> | undefined;
      throw new HttpError(response.status, message, errorType, data);
    } catch (error) {
      if (error instanceof HttpError) throw error;
      throw new HttpError(response.status, response.statusText, response.statusText);
    }
  }
}

const get = async <T>(url_path: string, params: RequestInit = {}): Promise<T> => {
  // const accessToken = getAccessToken();
  const response = await fetch(`${env.NEXT_PUBLIC_XI_SERVER_URL}${url_path}`, {
    method: "GET",
    // headers: { Authorization: `Bearer ${accessToken}` },
    ...params,
  });

  await throwErrorIfResponseNotOk(response);
  return response.json();
};

const post = async <T>(
  url_path: string,
  body: Record<string, any> | FormData,
  options?: { signal?: AbortSignal },
): Promise<T> => {
  // const accessToken = getAccessToken();
  const isFormData = body instanceof FormData;
  const response = await fetch(`${env.NEXT_PUBLIC_XI_SERVER_URL}${url_path}`, {
    method: "POST",
    headers: isFormData
      ? {}
      : {
          // Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
    body: isFormData ? body : JSON.stringify(body),
    signal: options?.signal,
  });

  await throwErrorIfResponseNotOk(response);
  return response.json();
};

export const api = {
  get,
  post,
};
